/**
 * @file ClockWidget.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-02-02
 * @modified 2026-02-02
 */

import React from 'react';
import AnalogClock from '../components/AnalogClock';

function ClockWidget() {
  return (
    <div className="dashboard-card clock-card">
      <div className="card-body">
        <AnalogClock />
      </div>
    </div>
  );
}

export default ClockWidget;
